import React, { useState } from "react";

import {
  Button,
  Dialog,
  Slide,
} from "@mui/material";

import { GoCheckCircleFill } from "react-icons/go";
import { MdDeleteOutline } from "react-icons/md";
import { MdOutlineSportsSoccer } from "react-icons/md";
import { PaymentAPI } from "../../api/PaymentAPI";
import { useSelector } from "react-redux";
import { PaymentIcon } from "react-svg-credit-card-payment-icons/dist";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const CardView = ({
  cardDetails,
  defaultCard,
  refreshTrue,
  setSuccess,
  startLoading,
  finishLoading,
  paymentMethodSize,
}) => {
  const { userInfo, clubId } = useSelector((store) => store.user)
  const [openDeletePopup, setOpenDeletePopup] = useState(false);
  const isDefault = cardDetails?.paymentId === defaultCard;
  const last4 = cardDetails?.customerPaymentCardInfo?.last4Digits;

  const removeCardFromUser = async () => {
    try {
      startLoading("loading2");
      const paymentMethodInfo = {
        paymentMethodId: cardDetails.paymentId,
        userId: userInfo.userId,
        clubId: clubId,
      };
      await PaymentAPI.postRemovePaymentMethod(paymentMethodInfo);
      finishLoading("loading2");
      refreshTrue();
    } catch (error) {
      finishLoading("loading2");
      setSuccess({ status: "error", data: error.message });
    }
  };

  const makeDefaultCard = async () => {
    try {
      const setPaymentInfo = {
        userId: userInfo.userId,
        paymentMethodId: cardDetails?.paymentId,
        clubId: clubId,
      };
      startLoading("loading2");
      await PaymentAPI.postSetPaymentDefaultCard(setPaymentInfo);
      setSuccess({ status: "success", data: 'Successfully made default this card' });
      refreshTrue();
      finishLoading("loading2");
    } catch (error) {
      setSuccess({ status: "error", data: 'something went wrong !!' });
      finishLoading("loading2");
    }
  };

  return (
    <div
      data-testid="card-view-container"
      className={
        isDefault
          ? "card-view-container active"
          : "card-view-container"
      }
    >
      <div className="card-view-header">
        <div className="card-view-title-row">
          <p>{cardDetails.customerPaymentCardInfo.funding} card</p>
          {isDefault && (
            <span data-testid="card-default-check" className="card-default-check">
              <GoCheckCircleFill className="card-default-check-icon" />
              Default
            </span>
          )}
        </div>
        <div data-testid="delete-card-item" className="delete-card-item">
          <button
            type="button"
            className="edit-card-button"
            data-testid="edit-card-button"
            aria-label="Remove card"
            onClick={() => setOpenDeletePopup(true)}
          >
            <MdDeleteOutline />
          </button>
        </div>
      </div>
      <div className="card-view-info">
        <PaymentIcon format="flatRounded"  type={cardDetails?.customerPaymentCardInfo?.cardBrand}/>
        <div className="card-secret-number">
          <div className="card-mask">
            <MdOutlineSportsSoccer data-testid="card-number" className="card-number" />
            <MdOutlineSportsSoccer data-testid="card-number" className="card-number" />
            <MdOutlineSportsSoccer data-testid="card-number" className="card-number" />
            <MdOutlineSportsSoccer data-testid="card-number" className="card-number" />
          </div>
          <div className="card-mask">
            <MdOutlineSportsSoccer data-testid="card-number" className="card-number" />
            <MdOutlineSportsSoccer data-testid="card-number" className="card-number" />
            <MdOutlineSportsSoccer data-testid="card-number" className="card-number" />
            <MdOutlineSportsSoccer data-testid="card-number" className="card-number" />
          </div>
          <div className="card-mask">
            <MdOutlineSportsSoccer data-testid="card-number" className="card-number" />
            <MdOutlineSportsSoccer data-testid="card-number" className="card-number" />
            <MdOutlineSportsSoccer data-testid="card-number" className="card-number" />
            <MdOutlineSportsSoccer data-testid="card-number" className="card-number" />
          </div>
          <div className="card-last-digit">
            {last4}
          </div>
        </div>
      </div>
      {!isDefault && (
        <button type="button" className="card-set-default-btn" onClick={makeDefaultCard}>
          Set default
        </button>
      )}
      <Dialog
        open={openDeletePopup}
        TransitionComponent={Transition}
        onClose={() => setOpenDeletePopup(false)}
        aria-labelledby="remove-card-title"
        PaperProps={{ className: "remove-card-dialog" }}
      >
        <div className="remove-card-dialog-body">
          <p className="remove-card-kicker">Payment</p>
          <h2 id="remove-card-title">Remove this card?</h2>
          <p className="remove-card-lead">
            {last4 ? `•••• ${last4} will be removed from your payment methods.` : "This card will be removed from your payment methods."}
          </p>
          <div className="remove-card-actions">
            <Button onClick={() => setOpenDeletePopup(false)} variant="outlined">Cancel</Button>
            <Button data-testid="delete-card-btn" onClick={() => {
              setOpenDeletePopup(false);
              removeCardFromUser();
            }} variant="contained">Remove card</Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default CardView;
